import type { GNBDropdownMenu } from '@/components/gnb/constants';

/**
 * 원격구성 키들을 관리하는 enum
 *
 * 각 키는 useCustomInhouseRemoteConfig 훅에서 사용되며,
 * 원격에서 값을 변경할 수 있는 설정들을 관리합니다.
 */
export enum RemoteConfigKeys {
  /**
   * GNB(Global Navigation Bar)의 교육 드롭다운/아코디언 내부 메뉴 목록 및 커스텀 뱃지
   */
  GNB_EDU_MENU = 'GNB_교육_탭',
  /**
   * 항해 플러스 결제페이지 하단 FAQ
   */
  HANGHAE_PLUS_PAYMENT_FAQ = '항해_플러스_결제페이지_하단_FAQ',
  HANGHAE_LITE_PAYMENT_FAQ = '항해_LITE_결제페이지_하단_FAQ',
}

/**
 * 원격구성 키의 타입 정보를 관리하는 타입
 * 각 키가 어떤 타입의 값을 반환하는지 명시
 */
export type RemoteConfigKeyTypes = {
  [RemoteConfigKeys.GNB_EDU_MENU]: { items: GNBDropdownMenu['items'] };
  [RemoteConfigKeys.HANGHAE_PLUS_PAYMENT_FAQ]: Record<
    string,
    Array<{
      question: string;
      answers: string[];
    }>
  >;
  [RemoteConfigKeys.HANGHAE_LITE_PAYMENT_FAQ]: Record<
    string,
    Array<{
      category: string;
      question: string;
      answers: string[];
    }>
  >;
};

/**
 * 타입 안전한 원격구성 훅을 위한 헬퍼 타입
 */
export type RemoteConfigValue<T extends RemoteConfigKeys> =
  RemoteConfigKeyTypes[T];
